import moment from 'moment'
import { createSlice } from '@reduxjs/toolkit'
// import { default_equipment_profile } from 'functions/equipmentUtils';
import { full_equipment_profile } from 'functions/equipmentUtils';

// Initial state
const initialState = {
    inputs: {
        sport: 'cross-country',
        assessment: null,
        progressionLevel: 0,
        progressionLevelScore: 0,
        injuries: [],
        injuryHistory: [],
        aRace: {
            id: 1,
            name: 'Default Event',
            eventType: 'a-race',
            eventTrainingStartDate: moment().utc().local().format('YYYY-MM-DD'),
            eventDate: moment().utc().add(20, 'week').local().format('YYYY-MM-DD'),
            deloadAfterEvent: 1,
            programEndDate: moment().utc().add(24, 'week').local().format('YYYY-MM-DD')
        },
        bAndCRaces: [],
        equipmentProfile: JSON.parse(JSON.stringify(full_equipment_profile)),
        volumeProgressionModifier: 0,
        workoutTemplateExerciseProgressionModifiers: {
            'strength-session-a': [
                {
                    "name": "Warm Up",
                    "phaseKey": "warm-up",
                    "slotExerciseProgressionModifiers": [
                        0,
                        0,
                        0
                    ]
                },
                {
                    "name": "Prep",
                    "phaseKey": "prep",
                    "slotExerciseProgressionModifiers": [
                        0,
                        0,
                        0,
                        0
                    ]
                },
                {
                    "name": "Main 1",
                    "phaseKey": "main-1",
                    "slotExerciseProgressionModifiers": [
                        0,
                        0
                    ]
                },
                {
                    "name": "Main 2",
                    "phaseKey": "main-2",
                    "slotExerciseProgressionModifiers": [
                        0,
                        0
                    ]
                },
                {
                    "name": "Accessory 1",
                    "phaseKey": "accessory-1",
                    "slotExerciseProgressionModifiers": [
                        0,
                        0
                    ]
                }
            ],
            'strength-session-b': [
                {
                    "name": "Warm Up",
                    "phaseKey": "warm-up",
                    "slotExerciseProgressionModifiers": [
                        0,
                        0,
                        0
                    ]
                },
                {
                    "name": "Prep",
                    "phaseKey": "prep",
                    "slotExerciseProgressionModifiers": [
                        0,
                        0,
                        0,
                        0
                    ]
                },
                {
                    "name": "Main 1",
                    "phaseKey": "main-1",
                    "slotExerciseProgressionModifiers": [
                        0,
                        0
                    ]
                },
                {
                    "name": "Main 2",
                    "phaseKey": "main-2",
                    "slotExerciseProgressionModifiers": [
                        0,
                        0
                    ]
                },
                {
                    "name": "Accessory 1",
                    "phaseKey": "accessory-1",
                    "slotExerciseProgressionModifiers": [
                        0,
                        0
                    ]
                }
            ],
        },
        overrides: []
    }
}

// Generator Slice
const generatorSlice = createSlice({
  name: 'generator',
  initialState,
  reducers: {
    setSport: (state, action) => { state.inputs.sport = action.payload },
    setAssessment: (state, action) => { state.inputs.assessment = action.payload },
    setInjuries: (state, action) => { state.inputs.injuries = action.payload },
    setInjuryHistory: (state, action) => { state.inputs.injuryHistory = action.payload },
    setAssessmentExerciseSetRepsCompleted: (state, action) => { 

        var currentAssessmentSet = state.inputs.assessment.phases[action.payload.phaseIndex].exercises[action.payload.exerciseIndex].sets[action.payload.setIndex]

        switch (action.payload.lateralKey) {

            case 'unilateral-left':
                
                currentAssessmentSet.completedSetData.setUnitsCompleted.leftSide = action.payload.repsCompleted

                break

            case 'unilateral-right':

                currentAssessmentSet.completedSetData.setUnitsCompleted.rightSide = action.payload.repsCompleted

                break

            case 'bilateral':
                
                currentAssessmentSet.completedSetData.setUnitsCompleted = action.payload.repsCompleted     
                
                break
        
        }

    },
    setAssessmentExerciseSetDifficulty: (state, action) => { 

        var currentAssessmentSet = state.inputs.assessment.phases[action.payload.phaseIndex].exercises[action.payload.exerciseIndex].sets[action.payload.setIndex]

        currentAssessmentSet.completedSetData.difficulty = action.payload.difficulty 
        
    },
    setProgressionLevel: (state, action) => { state.inputs.progressionLevel = action.payload },
    setProgressionLevelScore: (state, action) => { state.inputs.progressionLevelScore = action.payload },
    setARaceEventTrainingStartDate: (state, action) => { state.inputs.aRace.eventTrainingStartDate = action.payload },
    setARaceEventDate: (state, action) => { 

        state.inputs.aRace.eventDate = action.payload 

        if (state.inputs.aRace.deloadAfterEvent) state.inputs.aRace.programEndDate = moment(state.inputs.aRace.eventDate).add(4, 'week').format('YYYY-MM-DD')
        else state.inputs.aRace.programEndDate = moment(state.inputs.aRace.eventDate).format('YYYY-MM-DD')

    },
    setARaceDeloadAfterEvent: (state, action) => { 

        state.inputs.aRace.deloadAfterEvent = action.payload 

        if (action.payload) state.inputs.aRace.programEndDate = moment(state.inputs.aRace.eventDate).add(4, 'week').format('YYYY-MM-DD')
        else state.inputs.aRace.programEndDate = moment(state.inputs.aRace.eventDate).format('YYYY-MM-DD')
        
    },
    setBAndCRaces: (state, action) => { 
        state.inputs.bAndCRaces = action.payload 
    },
    toggleEquipmentProfileBaseEquipment: (state, action) => { 
        
        state.inputs.equipmentProfile.baseEquipment[action.payload.equipmentKey] = !state.inputs.equipmentProfile.baseEquipment[action.payload.equipmentKey]
        
    },
    setVolumeProgressionModifier: (state, action) => { state.inputs.volumeProgressionModifier = action.payload },
    setExerciseProgressionSlotModifier: (state, action) => {

        var currentPhase = state.inputs.workoutTemplateExerciseProgressionModifiers[action.payload.workoutTemplateKey][action.payload.phaseIndex]

        currentPhase.slotExerciseProgressionModifiers[action.payload.slotIndex] = parseInt(action.payload.newSlotModifier)

    },
    addNewOverride: (state, action) => {
        state.inputs.overrides.push(action.payload)
    },
    removeOverride: (state, action) => {
      const filtered = state.inputs.overrides.filter((_, index) => index !== action.payload);
      state.inputs.overrides = filtered.length === 0 ? [] : filtered;
    },
    clearOverrides: (state) => { state.inputs.overrides = []},
    resetGeneratorState: () => initialState
  },
});

export const { 
    setSport,
    setAssessment,
    setInjuries,
    setInjuryHistory,
    setAssessmentExerciseSetRepsCompleted,
    setAssessmentExerciseSetDifficulty,
    setProgressionLevel,
    setProgressionLevelScore,
    setARaceEventTrainingStartDate,
    setARaceEventDate,
    setARaceDeloadAfterEvent,
    setBAndCRaces,
    toggleEquipmentProfileBaseEquipment,
    setVolumeProgressionModifier,
    setExerciseProgressionSlotModifier,
    addNewOverride,
    removeOverride,
    clearOverrides,
    resetGeneratorState 
} = generatorSlice.actions;

export default generatorSlice.reducer;